import React from 'react';
import './FieldStyles.css';

const TextField = ({ value, onChange, isEmpty, hasTranslation }) => {
  // Определяем, нужно ли использовать textarea для длинных текстов
  // Используем textarea если текст длиннее 50 символов или содержит переносы строк
  const isLongText = value && (value.length > 50 || value.includes('\n'));

  if (isLongText) {
    return (
      <div className={`field-wrapper ${isEmpty ? 'empty' : ''}`}>
        <textarea
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="text-field textarea-field"
          placeholder={hasTranslation ? "Введите текст..." : "Перевод отсутствует"}
          rows={Math.min(Math.max(3, Math.ceil(value.length / 80)), 10)}
        />
      </div>
    );
  }

  return (
    <div className={`field-wrapper ${isEmpty ? 'empty' : ''}`}>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="text-field"
        placeholder={hasTranslation ? "Введите текст..." : "Перевод отсутствует"}
      />
    </div>
  );
};

export default TextField;
